import axios from "axios";
import { useEffect, useState } from "react";
import type { Countries } from "./useContries.d";

const URL = "https://restcountries.com/v2/all?fields=name,alpha2Code";

const useContries = () => {
  const [countries, setCountries] = useState<Countries[]>([]);

  const getCountries = async () => {
    try {
      const { data } = await axios.get<Countries[]>(URL);
      setCountries(data);
    } catch (error) {
      setCountries([]);
      throw Error(error.message);
    }
  };

  useEffect(() => {
    getCountries();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { countries };
};

export default useContries;
